import { useState } from "react";
import { groupCategories, groups } from "@/mocks/home";

export default function Groups() {
  const [active, setActive] = useState("全部");

  const filtered = active === "全部" ? groups : groups.filter((group) => group.category === active);

  return (
    <section id="groups" className="anchor-offset bg-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">单身群</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            加入一个群，从共同话题聊起
          </h2>
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            比起一对一搭讪，群聊的机会更多、压力更小。选择一个符合你生活方式的群，先当个安静的观察者也可以，
            等到有想接的话头再开口。
          </p>
        </div>

        <div className="mb-6 flex flex-wrap gap-2" role="tablist" aria-label="单身群分类筛选">
          {groupCategories.map((category) => {
            const isActive = category === active;
            return (
              <button
                key={category}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(category)}
                className={`rounded-full px-1 py-1 cursor-pointer transition-colors ${
                  isActive ? "" : "hover:opacity-80"
                }`}
              >
                <span
                  className={`block rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50 text-foreground-700 border border-background-300"
                  }`}
                >
                  {category}
                </span>
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((group) => (
            <article
              key={group.name}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between gap-3">
                <h3 className="font-heading text-base text-foreground-950 md:text-lg">{group.name}</h3>
                <span className="shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-medium text-accent-800">
                  {group.category}
                </span>
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-map-pin-line" aria-hidden="true"></i>
                  {group.city}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-user-line" aria-hidden="true"></i>
                  {group.members}
                </span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">{group.desc}</p>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="rounded-lg border border-background-300 bg-background-50 px-5 py-6 text-center text-sm text-foreground-600">
            这个分类下暂时没有群组，换一个分类看看吧。
          </p>
        )}
      </div>
    </section>
  );
}